export const getAge = (birth) => {
  let today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  let m = today.getMonth() - birth.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};

export function getAgeInYearsMonths(birthDate, currentDate = new Date()) {
  const nacimiento = new Date(birthDate);
  const actual = new Date(currentDate);

  let years = actual.getFullYear() - nacimiento.getFullYear();
  let months = actual.getMonth() - nacimiento.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  return `${years} ${years === 1 ? "año" : "años"}, ${months} ${
    months === 1 ? "mes" : "meses"
  }`;
}
